import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
import bestPic from 'images/content/Benefits-of-Group-Health.jpeg'

const SecondSection = () => {
    return (
        <div className='flex flex-col lg:flex-row items-center md:justify-between gap-8'>
            <div className='min-w-lg min-h-lg'>
                <img src={bestPic} alt='plans' />
            </div>
            <div className='w-full max-w-xl space-y-4'>
                <div className='text-2xl sm:text-4xl font-bold'>Benefits of Group Health Insurance</div>
                <ul className='sm:text-lg space-y-4'>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> Retains good employees in a competitive economy</li>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> Provides a competitive edge to attractive quality employees</li>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> Reduces the likelihood of sick days and personal days off</li>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> Increases employee productivity through reduced personal anxiety</li>
                </ul>
            </div>
        </div>
    );
}

export default SecondSection;
